"use client";

import * as React from "react";
import { cn } from "@/app/lib/utils";

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
   value?: number;
   max?: number;
   color?: "success" | "warning" | "destructive" | "default";
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
   ({ className, value = 0, max = 100, color = "default", ...props }, ref) => {
      const percentage = Math.min(100, Math.max(0, (value / max) * 100));

      const getColorClasses = (color: string) => {
         switch (color) {
            case "success":
               return "bg-green-500";
            case "warning":
               return "bg-yellow-500";
            case "destructive":
               return "bg-red-500";
            default:
               return "bg-blue-500";
         }
      };

      return (
         <div
            ref={ref}
            className={cn(
               "relative h-2 w-full overflow-hidden rounded-full bg-muted",
               className
            )}
            {...props}
         >
            <div
               className={cn(
                  "h-full w-full flex-1 transition-all duration-300",
                  getColorClasses(color)
               )}
               style={{
                  transform: `translateX(-${100 - percentage}%)`
               }}
            />
         </div>
      );
   }
);

Progress.displayName = "Progress";

export { Progress };
